import React from "react";
import { useNavigate, Outlet } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { TopBar } from "@/components/layout/TopBar";
import { Sidebar } from "@/components/layout/Sidebar";

const ADMIN_ROLES = new Set(["super_admin", "admin"]);

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900" data-testid="app-layout">
      <TopBar user={user} onLogout={handleLogout} />
      <div className="flex">
        <Sidebar isAdmin={ADMIN_ROLES.has(user?.role)} />
        <main className="flex-1 p-8 min-w-0">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
